import { render, staticRenderFns } from "./ProjetoTipoForm.vue?vue&type=template&id=950f3cb8&"
import script from "./ProjetoTipoForm.vue?vue&type=script&lang=js&"
export * from "./ProjetoTipoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports